import { useWidgetContext } from '../../../../../Widget'
import { ListingProfileWidgetAddressForm } from '../ListingProfileWidgetAddressForm'
import { ListingProfileWidgetAddressReadView } from '../ListingProfileWidgetAddressReadView'

function ListingProfileWidgetAddressContent() {
  const { handleDisableEditMode, isEditMode } = useWidgetContext()

  return isEditMode ? (
    <ListingProfileWidgetAddressForm
      onClose={handleDisableEditMode}
      onSuccess={handleDisableEditMode}
    />
  ) : (
    <ListingProfileWidgetAddressReadView />
  )
}

export default ListingProfileWidgetAddressContent
